import { render, staticRenderFns } from "./TokenPowerSetting.vue?vue&type=template&id=5dcddb7d&scoped=true"
import script from "./TokenPowerSetting.vue?vue&type=script&lang=js"
export * from "./TokenPowerSetting.vue?vue&type=script&lang=js"
import style0 from "./TokenPowerSetting.vue?vue&type=style&index=0&id=5dcddb7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcddb7d",
  null
  
)

export default component.exports